import MultiSelect from '../components/MultiSelect.vue';

export default {
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    },
  },
  components: {
    MultiSelect
  },
  methods: {
    atualizar(selecionados) {
      this.$aplicaFiltroEmURL(this.filtro.filtro, selecionados, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: selecionados
      });
    },
  },
}